module.exports = __webpack_public_path__ + "img/1f_r_joy.c1e50155.png";